module.exports = __webpack_public_path__ + "img/404.d704b806.svg";